import { ContractorTopSellRptService } from '../services';
import { ContractorTopSellRptConstants } from '../constants';
import { alertActions } from '.';

export const ContractorTopSellRptAction = {
    getAll,
    loadingData,
    exportData,
    fetchDealers // New action added
};



function getAll(obj) {
    return dispatch => {
        dispatch(request());

        ContractorTopSellRptService.GetDealerInvoicing(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))


            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type:  ContractorTopSellRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type:  ContractorTopSellRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type:  ContractorTopSellRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type:  ContractorTopSellRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        ContractorTopSellRptService .GetDealerInvoicing(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type:  ContractorTopSellRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type:  ContractorTopSellRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type:  ContractorTopSellRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type:  ContractorTopSellRptConstants.LOADING_REQUEST, isbool
    }
}

// New function to fetch dealer list
function fetchDealers() {
    return dispatch => {
        dispatch(request());
        ContractorTopSellRptService .GetDealers().then(
            response => {
                dispatch(success(response.ResponseData));
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type:  ContractorTopSellRptConstants.GETDEALERS_REQUEST }; }
    function success(datas) { return { type:  ContractorTopSellRptConstants.GETDEALERS_SUCCESS, datas }; }
    function failure(error) { return { type:  ContractorTopSellRptConstants.GETDEALERS_FAILURE, error }; }
}